import * as Yup from "yup";

import { logisticsRequirementRowSchema } from "./portalValidationSchema";

const getZonesAndLogisticalRequirementsValidationSchema = (
  messages,
  requirementCatalog = [],
) =>
  Yup.object().shape({
    zones_attributes: Yup.array()
      .of(
        Yup.object().shape({
          name: Yup.string()
            .trim()
            .required(messages.required)
            .max(50, messages.maxFiftyChars),
          supervisor_id: Yup.mixed().nullable(),
          supervisor_name: Yup.string().max(200, messages.maxTwoHundredChars).nullable(),
          manager_id: Yup.mixed().nullable(),
          manager_name: Yup.string().nullable(),
          manager_email: Yup.string().nullable(),
          manager_phone: Yup.string().nullable(),
        }),
      )
      .min(1, messages.zoneRequired),
    logistics_requirements_attributes: Yup.array().of(
      logisticsRequirementRowSchema(messages, requirementCatalog),
    ),
  });

export default getZonesAndLogisticalRequirementsValidationSchema;